var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:('height: '+(_vm.small ? '26px' : '50px')),attrs:{"href":_vm.finalGooglePlayLink,"target":"_blank"}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"alt":_vm.$t('alts.googlePlay'),"src":require("@/assets/googlePlay.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }